<template>
    <div>
        <el-row class="header">
            <el-col :xs="8" :sm="1" :md="1" :lg="2" :xl="4"></el-col>
            <el-col :xs="4" :sm="3" :md="3" :lg="3" :xl="2" class="header-nav">
            <div class="header-logo">
                <img src="../assets/logo.png" alt="">
            </div>
            </el-col>
            <el-col :xs="4" :sm="20" :md="15" :lg="17" :xl="11" class="navcenter">
            <navMenu></navMenu>
            </el-col>
            <el-col :xs="8" :sm="2" :md="3" :lg="4" :xl="3">
            <div class="header-right">
                <div class="header-login" @click="login" v-if="isLogin">
                <span>{{$t('user.login')}}</span>
                </div>
                <div class="languagewrap">
                <span class="showLang">{{ value == '中文' ? 'English' : '中文'}}</span>
                <el-select v-model="value" placeholder="Language" @change="changeLang">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                </div>
            </div>
            </el-col>
            <el-col :xs="8" :sm="1" :md="1" :lg="2" :xl="4">
            </el-col>
        </el-row>
        <el-row class="mobile-header">
            <el-col :xs="3" :sm="2">
            <div class="header-menu">
                <img v-if="isShowMenu" @click="showMenu" src="../assets/menu_icon.png" alt="">
                <i v-else @click="closeMenu" class="el-icon-close" ></i>
            </div>
            </el-col>
            <el-col :xs="userInfo.nickname.length == 0 ? 13 : 15" :sm="16">ITSH 家纺展</el-col>
            <el-col :xs="userInfo.nickname.length == 0 ? 8 : 6" :sm="4">
            <div class="mobile-header-right">
                <span @click="login" v-if="userInfo.nickname.length == 0">{{$t('user.logintext')}}</span>
                <div class="language">
                <p :class="[langcur == 0 ? 'act': '']" @click="changeMLang(0)">中文</p>
                <p :class="[langcur == 1 ? 'act': '']" @click="changeMLang(1)">English</p>
                </div>
            </div>
            </el-col>
        </el-row>
        <moblienavMenu v-if="!isShowMenu"></moblienavMenu>
    </div>
</template>
  
<script>
import navMenu from "../components/navMenu.vue";
import moblienavMenu from "../components/moblienavMenu.vue";
import { getUser } from "@/api/api";
export default {
    components: {
        navMenu,
        moblienavMenu
    }, 
    data() {
        return {
        isLogin: true,
        langcur: 0,
        memberid: 0,
        options: [{
            value: '中文',
            label: '中文'
        }, {
            value: 'English',
            label: 'English'
        }],
        value:'',
        newLang:'中文',
        isShowMenu: true,
        userInfo:{
            nickname: ''
        },
        };
    },
    mounted() {
    this.memberid = localStorage.getItem('memberid');
    this.uuid = localStorage.getItem('uuid');
    this.loggedIn();
    if(localStorage.getItem('languageSet') == 'zh' || localStorage.getItem('languageSet') == null){
        this.value = '中文';
        this.newLang = 'English';
        localStorage.setItem('languageSet','zh');
    }else{
        this.value = 'English';
        this.newLang = '中文';
        localStorage.setItem('languageSet','en');
    }
    this.langSet = localStorage.getItem('languageSet') || 'zh';
    if(this.langSet == 'zh'){
        this.langcur = 0;
    }else{
        this.langcur = 1;
    }
    this.getData()
    },
    created() {
    },
    methods: {
    login(){
        this.$router.push({
        name: 'login'
        });
    },
    changeMLang(index){
        this.langcur = index;
        if(this.langcur == 0){
        this.$i18n.locale = 'zh';
        }else{
        this.$i18n.locale = 'en';
        }
        localStorage.setItem('languageSet',this.$i18n.locale);
        location.reload();
    },
    showMenu(){
        this.isShowMenu = false;
    },
    closeMenu(){
        this.isShowMenu = true;
    },
    getData(){
        let data = this.$qs.stringify({
        memberid: this.memberid,
        uuid:this.$uuid
        })
        getUser(data).then(res=>{
        console.log(res);
        if(res.data.errno == 0){
            this.userInfo = res.data.rst;
            let improve = localStorage.getItem("improve");
            if(!this.userInfo.nickname ||!this.userInfo.country || !this.userInfo.nickname || !this.userInfo.nickname ||this.userInfo.nickname=='请填写姓名' ||this.userInfo.nickname=='请填写手机号' ||this.userInfo.nickname=='请填写公司名称'||this.userInfo.country=='请填写国家'){
                console.log(improve,"aaa")
                localStorage.setItem('improve',true);
            }else{
            console.log(improve,"bbb")
                localStorage.setItem('improve',false);
                console.log(improve,"ccc")
                if(improve==null){
                console.log("zzz")
                this.$router.push({ path: "/pair" });
                }else if(improve&&improve!=='false'){
                console.log("xxx")
                this.$router.push({ path: "/pair" });
                }
            }
        }else{
            if(localStorage.getItem('Flag')){
            localStorage.removeItem('Flag');
            location.reload();
            }
        }
        }).catch(err=>{
        console.log(err)
        })
    },
    changeLang(e){
        console.log(e)
        this.$i18n.locale == 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh'
        localStorage.setItem('languageSet',this.$i18n.locale);
        //console.log(localStorage.getItem('languageSet'));
        location.reload();
    },
    loggedIn(){
        this.memberid = localStorage.getItem('memberid');
        //console.log(this.memberid)
        if(this.memberid == 0 || this.memberid == null){
        this.isLogin = true;
        }else{
        this.isLogin = false;
        }
    }
    }
};
</script>

<style lang="scss">
.header{height: 75px;background: #9B8B1C;display: flex;align-items: center;}
.header-logo{width: 100%;}
.header-logo img{width: 100%;}
.header-right{width: 100%;font-size: 15px;color: #fff;text-align: center;cursor: pointer;display: flex;}
.header-right .header-login{background: #9B8B1C;height: 38px;line-height: 38px;border-radius: 7px;;margin-right: 2%;padding: 0 3%;}
.header-right .lang{background: #CAC28A;border-radius: 30px;width: 46%;display: flex;justify-content: center;height: 38px;line-height: 30px;padding: 5px 10px;box-sizing: border-box;}
.header-right .lang p{width: 50%;border-radius: 30px;}
.header-right .lang p.cur{background: #fff;color: #CAC28A;}
.header-nav .el-row,.container .el-col{height: 100%;}
.el-col{border-radius: 0 !important;}
.navcenter.el-col{min-height: 0;height: 100%;}
.languagewrap{width: 45%;position: relative;}
.languagewrap .el-select .el-input__inner{height: 38px;border:0 none;background-color:#9B8B1C;color: #ffffff;padding: 0 10px;border-radius: 7px;margin-top: 0;visibility: hidden;}
.languagewrap .el-select .el-input .el-select__caret{color: #fff;}
.showLang{
    position: absolute;
    top:10px;
    left: 30px;
}
.mobile-header{display: none;}
@media only screen and (max-width: 767px){

.header{display: none;}
.mobile-header{
    color: #fff;
    display: block;
    height: 0.88rem;
    text-align: center;
    line-height: 0.88rem;
    background:#CAC28A;
    .header-menu{
    img{
        width: 0.36rem;
        height: 0.3rem;
    }
    i{
        font-size: 24px;
        position: relative;
        top: 2px;
    }
    }
    .mobile-header-right{
    display: flex;
    height: 0.88rem;
    align-items: center;
    padding-right: 0.2rem;
    justify-content: space-between;
    .language{
        width: 1.6rem;
        height: 0.48rem;
        display: flex;
        line-height: 0.4rem;
        background:#CAC28A;
        border-radius: 24px;
        padding: 0.05rem;
        box-sizing: border-box;
        z-index: 99;
        p{
        flex: 1;
        font-size: 12px;
        height: 100%;
        text-align: center;
        }
        .act{
        color: #CAC28A;
        background: #fff;
        border-radius: 14px;
        }
    }
    }
}
}
</style>
